import { Cart } from './cart.model';
import { ProductOptionCode } from './product.model';

export const mockCart: Cart = {
  initialFees: {
    erf: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
    frf: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
  },
  initialSubTotal: {
    amount: 1344,
    currency: 'USD',
    display: '$1,344.00',
  },
  initialTax: {
    amount: 0,
    currency: 'USD',
    display: '$0.00',
  },
  initialTotal: {
    amount: 1344,
    currency: 'USD',
    display: '$1,344.00',
  },
  items: [
    {
      details: {
        CGROUP1_CONTAINER_SIZE: {
          name: 'Container group 1 container size',
          value: '020.00',
        },
        CGROUP1_CONTAINER_TYPE: {
          name: 'Container group 1 container type',
          value: 'RO',
        },
        CGROUP1_DISPOSAL: {
          name: 'Container group 1 disposal',
          value: 'AZ01',
        },
        CGROUP1_WEEKLY_LIFTS: {
          name: 'Container group 1 weekly lifts',
          value: 0,
        },
        CGROUP2_CONTAINER_SIZE: {
          name: 'Container group 2 container size',
          value: '000.00',
        },
        CGROUP2_WEEKLY_LIFTS: {
          name: 'Container group 2 weekly lifts',
          value: 0,
        },
        CGROUP3_CONTAINER_SIZE: {
          name: 'Container group 3 container size',
          value: '000.00',
        },
        CGROUP3_WEEKLY_LIFTS: {
          name: 'Container group 3 weekly lifts',
          value: 0,
        },
        DELIVERY: {
          name: 'Delivery fee (DEL)',
          value: 0,
        },
        DRY_RUN: {
          name: 'Dry run fee (DRY)',
          value: 181.5,
        },
        ES_CODE: {
          name: 'Extended service charge code',
          value: 'ES9',
        },
        ES_DAYS: {
          name: 'Days included before extra service charges apply',
          value: 9,
        },
        ES_PRICE: {
          name: 'Extended service fee',
          value: 9,
        },
        EXTRA_LIFTS: {
          name: 'Extra lift fee (EXT)',
          value: 0,
        },
        EXTRA_PICKUP: {
          name: 'Extra residential pick fee (EXR)',
          value: 0,
        },
        EXTRA_YARDS: {
          name: 'Extra yardage fee (EXY)',
          value: 0,
        },
        INCLUDED_TONS: {
          name: 'Weight limit in tons',
          value: 5,
        },
        INITIAL_ADMIN_FEE_APPLIES: {
          name: 'Initial admin fee applies',
          value: false,
        },
        INITIAL_ERF_FEE_APPLIES: {
          name: 'Initial ERF fee applies',
          value: false,
        },
        INITIAL_FRF_FEE_APPLIES: {
          name: 'Initial FRF fee applies',
          value: false,
        },
        MONTHLY_ADMIN_FEE_APPLIES: {
          name: 'Monthly admin fee applies',
          value: false,
        },
        MONTHLY_ERF_FEE_APPLIES: {
          name: 'Monthly ERF fee applies',
          value: false,
        },
        MONTHLY_FRF_FEE_APPLIES: {
          name: 'Monthly FRF fee applies',
          value: false,
        },
        MOVE_FEES: {
          name: 'Container exchange fee (EXC)',
          value: 0,
        },
        OVERAGE_PRICE: {
          name: 'Overage price per ton',
          value: 51,
        },
        RELOCATE: {
          name: 'Relocate fee (REL)',
          value: 181.5,
        },
        REMOVAL: {
          name: 'Container removal fee (REM)',
          value: 0,
        },
        RENEWAL_TERM: {
          name: 'Renewal term in months after contract expires',
          value: 1,
        },
        TERMS_IDENTIFIER: {
          name: 'Terms & Conditions Identifier',
          value: 'CTB_STD_T_01',
        },
        WASHOUT: {
          name: 'Container washout fee (WAS)',
          value: 0,
        },
      },
      id: 'L2NhcnRzL3J',
      initialPrice: {
        amount: 896,
        currency: 'USD',
        display: '$896.00',
      },
      initialSubTotal: {
        amount: 896,
        currency: 'USD',
        display: '$896.00',
      },
      items: [],
      modifierValues: {
        ADDED_FROM_CATEGORY_CODE: 'RES_LGC',
        DELIVERY_AND_PLACEMENT_DETAILS: '',
        ESTIMATED_DELIVERY_DATE: '2019-06-03',
        REQUESTED_COLLECTION_DATE: '2019-06-14',
        REQUESTED_SERVICE_START_DATE: '2100-06-03',
      },
      monthlyPrices: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      monthlySubTotals: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      name: 'Solid Waste Large Container– 20 Yard',
      product: {
        categoryCode: 'RES_ABC',
        code: '020.00_LGC_MSW',
        constituents: [],
        details: {
          ALLOW_PURCHASE_BY_EXISTING_CUSTOMER: {
            name: 'Allow existing customers',
            value: true,
          },
          ALLOW_PURCHASE_WITHOUT_DIVISION: {
            name: 'Allow purchase without division',
            value: false,
          },
          CATEGORY_STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },
          CONTAINER_SIZE: {
            name: 'Container size code',
            value: '020.00',
          },
          CONTENT_RESTRICTION_NOTE: {
            name: 'Content restrictions note',
            value: '5 Tons',
          },
          DESCRIPTION: {
            name: 'Description',
            value:
              'Our 20 yard container is ideal for roofing projects, small remodels, spring and summer clean outs.',
          },
          GIS_SERVICE_AREA_TYPES: {
            name: 'GIS service area types',
            value: ['Industrial Temp'],
          },
          MAX_QUANTITY: {
            name: 'Max Quantity',
            value: 2,
          },
          MEASUREMENTS: {
            name: 'Measurements',
            value: '22\'9" L x 7\'8" W x 4\'5" H',
          },
          PRODUCT_FAMILY_NAME: {
            name: 'Product family name',
            value: 'Solid Waste Large Container',
          },
          SERVICE_FAMILY: {
            name: 'Service family',
            value: 'RES',
          },
          SERVICE_GROUP: {
            name: 'Service group',
            value: 'MSW',
          },
          SERVICE_LOCATOR_CODE: {
            name: 'Service locator code to use to determine whether category should be visible',
            value: [
              'Industrial C&D',
              'Industrial C&D Recycling',
              'Industrial OCC Recycling',
              'Industrial Single Stream Recycling',
              'Industrial/rolloff MSW (Compactor & Open Top)',
            ],
          },
          SERVICE_TYPE: {
            name: 'Category Service Type',
            value: 'Industrial Temp',
          },
          SIZE_COMPARISON_NOTE: {
            name: 'Size comparison note',
            value: 'Holds up to around 7-9 full size pickup truck loads',
          },
          SIZE_DESCRIPTION: {
            name: 'Container size human-readable description',
            value: '20 Yard Container',
          },
          STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },
        },
        name: 'Solid Waste Large Container– 20 Yard',
        options: [
          {
            choices: [
              {
                code: 'CF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.COMPACTOR_FLAG,
            name: 'Compactor',
          },
          {
            choices: [
              {
                code: 'SF-0.00',
                name: 'N/A',
              },
            ],
            code: ProductOptionCode.SERVICE_FREQUENCY,
            name: 'Service Frequency',
          },
          {
            choices: [
              {
                code: 'WF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.CASTERS_FLAG,
            name: 'Casters',
          },
          {
            choices: [
              {
                code: 'CTL-RO',
                name: 'RO',
              },
            ],
            code: ProductOptionCode.CONTAINER_TYPE_LGC,
            name: 'Container Type',
          },
          {
            choices: [
              {
                code: 'EF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.ENCLOSURE_FLAG,
            name: 'Enclosure',
          },
          {
            choices: [
              {
                code: 'LF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.LOCK_FLAG,
            name: 'Gravity Lock',
          },
          {
            choices: [
              {
                code: 'CL-01',
                name: 'Month-to-Month Service',
              },
            ],
            code: ProductOptionCode.CONTRACT_LENGTH,
            name: 'Contract Length',
          },
        ],
      },
      quantity: 2,
      skuCode: '020.00_LGC_MSW_RO_0.00_01_N_N_N_N',
      imageUrl:
        '/cms/sites/default/files/media/product-images/Cart_95_Trash_Persp_900x548_1.png',
    },
    {
      details: {
        CGROUP1_CONTAINER_SIZE: {
          name: 'Container group 1 container size',
          value: '020.00',
        },
        CGROUP1_CONTAINER_TYPE: {
          name: 'Container group 1 container type',
          value: 'RO',
        },
        CGROUP1_DISPOSAL: {
          name: 'Container group 1 disposal',
          value: 'AZ01',
        },
        CGROUP1_WEEKLY_LIFTS: {
          name: 'Container group 1 weekly lifts',
          value: 0,
        },
        CGROUP2_CONTAINER_SIZE: {
          name: 'Container group 2 container size',
          value: '000.00',
        },
        CGROUP2_WEEKLY_LIFTS: {
          name: 'Container group 2 weekly lifts',
          value: 0,
        },
        CGROUP3_CONTAINER_SIZE: {
          name: 'Container group 3 container size',
          value: '000.00',
        },
        CGROUP3_WEEKLY_LIFTS: {
          name: 'Container group 3 weekly lifts',
          value: 0,
        },
        DELIVERY: {
          name: 'Delivery fee (DEL)',
          value: 0,
        },
        DRY_RUN: {
          name: 'Dry run fee (DRY)',
          value: 181.5,
        },
        ES_CODE: {
          name: 'Extended service charge code',
          value: 'ES9',
        },
        ES_DAYS: {
          name: 'Days included before extra service charges apply',
          value: 9,
        },
        ES_PRICE: {
          name: 'Extended service fee',
          value: 9,
        },
        EXTRA_LIFTS: {
          name: 'Extra lift fee (EXT)',
          value: 0,
        },
        EXTRA_PICKUP: {
          name: 'Extra residential pick fee (EXR)',
          value: 0,
        },
        EXTRA_YARDS: {
          name: 'Extra yardage fee (EXY)',
          value: 0,
        },
        INCLUDED_TONS: {
          name: 'Weight limit in tons',
          value: 5,
        },
        INITIAL_ADMIN_FEE_APPLIES: {
          name: 'Initial admin fee applies',
          value: false,
        },
        INITIAL_ERF_FEE_APPLIES: {
          name: 'Initial ERF fee applies',
          value: false,
        },
        INITIAL_FRF_FEE_APPLIES: {
          name: 'Initial FRF fee applies',
          value: false,
        },
        MONTHLY_ADMIN_FEE_APPLIES: {
          name: 'Monthly admin fee applies',
          value: false,
        },
        MONTHLY_ERF_FEE_APPLIES: {
          name: 'Monthly ERF fee applies',
          value: false,
        },
        MONTHLY_FRF_FEE_APPLIES: {
          name: 'Monthly FRF fee applies',
          value: false,
        },
        MOVE_FEES: {
          name: 'Container exchange fee (EXC)',
          value: 0,
        },
        OVERAGE_PRICE: {
          name: 'Overage price per ton',
          value: 51,
        },
        RELOCATE: {
          name: 'Relocate fee (REL)',
          value: 181.5,
        },
        REMOVAL: {
          name: 'Container removal fee (REM)',
          value: 0,
        },
        RENEWAL_TERM: {
          name: 'Renewal term in months after contract expires',
          value: 1,
        },
        TERMS_IDENTIFIER: {
          name: 'Terms & Conditions Identifier',
          value: 'CTB_STD_T_01',
        },
        WASHOUT: {
          name: 'Container washout fee (WAS)',
          value: 0,
        },
      },
      id: '111222333',
      initialPrice: {
        amount: 448,
        currency: 'USD',
        display: '$448.00',
      },
      initialSubTotal: {
        amount: 448,
        currency: 'USD',
        display: '$448.00',
      },
      items: [],
      modifierValues: {
        ADDED_FROM_CATEGORY_CODE: 'RES_LGC',
        DELIVERY_AND_PLACEMENT_DETAILS: '',
        ESTIMATED_DELIVERY_DATE: '2019-05-28',
        REQUESTED_COLLECTION_DATE: '2019-06-10',
      },
      monthlyPrices: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      monthlySubTotals: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      name: 'Solid Waste Large Container– 20 Yard',
      product: {
        categoryCode: 'RES_LGC',
        code: '020.00_LGC_MSW',
        constituents: [
          {
            name: 'Constituant 0',
          },
        ],
        details: {
          ALLOW_PURCHASE_BY_EXISTING_CUSTOMER: {
            name: 'Allow existing customers',
            value: true,
          },
          ALLOW_PURCHASE_WITHOUT_DIVISION: {
            name: 'Allow purchase without division',
            value: false,
          },
          CATEGORY_STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },
          CONTAINER_SIZE: {
            name: 'Container size code',
            value: '020.00',
          },
          CONTENT_RESTRICTION_NOTE: {
            name: 'Content restrictions note',
            value: '5 Tons',
          },
          DESCRIPTION: {
            name: 'Description',
            value:
              'Our 20 yard container is ideal for roofing projects, small remodels, spring and summer clean outs.',
          },
          GIS_SERVICE_AREA_TYPES: {
            name: 'GIS service area types',
            value: ['Industrial Temp'],
          },
          MAX_QUANTITY: {
            name: 'Max Quantity',
            value: 2,
          },
          MEASUREMENTS: {
            name: 'Measurements',
            value: '22\'9" L x 7\'8" W x 4\'5" H',
          },
          PRODUCT_FAMILY_NAME: {
            name: 'Product family name',
            value: 'Solid Waste Large Container',
          },
          SERVICE_FAMILY: {
            name: 'Service family',
            value: 'SMC',
          },
          SERVICE_GROUP: {
            name: 'Service group',
            value: 'MSW',
          },
          SERVICE_LOCATOR_CODE: {
            name: 'Service locator code to use to determine whether category should be visible',
            value: [
              'Industrial C&D',
              'Industrial C&D Recycling',
              'Industrial OCC Recycling',
              'Industrial Single Stream Recycling',
              'Industrial/rolloff MSW (Compactor & Open Top)',
            ],
          },
          SERVICE_TYPE: {
            name: 'Category Service Type',
            value: 'Industrial Temp',
          },
          SIZE_COMPARISON_NOTE: {
            name: 'Size comparison note',
            value: 'Holds up to around 7-9 full size pickup truck loads',
          },
          SIZE_DESCRIPTION: {
            name: 'Container size human-readable description',
            value: '20 Yard Container',
          },
          STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },
        },
        name: 'Solid Waste Large Container– 20 Yard',
        options: [
          {
            choices: [
              {
                code: 'CF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.COMPACTOR_FLAG,
            name: 'Compactor',
          },
          {
            choices: [
              {
                code: 'SF-0.00',
                name: 'N/A',
              },
            ],
            code: ProductOptionCode.SERVICE_FREQUENCY,
            name: 'Service Frequency',
          },
          {
            choices: [
              {
                code: 'WF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.CASTERS_FLAG,
            name: 'Casters',
          },
          {
            choices: [
              {
                code: 'CTL-RO',
                name: 'RO',
              },
            ],
            code: ProductOptionCode.CONTAINER_TYPE_LGC,
            name: 'Container Type',
          },
          {
            choices: [
              {
                code: 'EF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.ENCLOSURE_FLAG,
            name: 'Enclosure',
          },
          {
            choices: [
              {
                code: 'LF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.LOCK_FLAG,
            name: 'Gravity Lock',
          },
          {
            choices: [
              {
                code: 'CL-01',
                name: 'Month-to-Month Service',
              },
            ],
            code: ProductOptionCode.CONTRACT_LENGTH,
            name: 'Contract Length',
          },
        ],
      },
      quantity: 1,
      skuCode: '020.00_LGC_MSW_RO_0.00_01_N_N_N_N',
      imageUrl:
        '/cms/sites/default/files/media/product-images/Cart_95_Trash_Persp_900x548_1.png',
    },
    {
      details: {
        CGROUP1_CONTAINER_SIZE: {
          name: 'Container group 1 container size',
          value: '020.00',
        },
        CGROUP1_CONTAINER_TYPE: {
          name: 'Container group 1 container type',
          value: 'RO',
        },
        CGROUP1_DISPOSAL: {
          name: 'Container group 1 disposal',
          value: 'AZ01',
        },
        CGROUP1_WEEKLY_LIFTS: {
          name: 'Container group 1 weekly lifts',
          value: 0,
        },
        CGROUP2_CONTAINER_SIZE: {
          name: 'Container group 2 container size',
          value: '000.00',
        },
        CGROUP2_WEEKLY_LIFTS: {
          name: 'Container group 2 weekly lifts',
          value: 0,
        },
        CGROUP3_CONTAINER_SIZE: {
          name: 'Container group 3 container size',
          value: '000.00',
        },
        CGROUP3_WEEKLY_LIFTS: {
          name: 'Container group 3 weekly lifts',
          value: 0,
        },
        DELIVERY: {
          name: 'Delivery fee (DEL)',
          value: 0,
        },
        DRY_RUN: {
          name: 'Dry run fee (DRY)',
          value: 181.5,
        },
        ES_CODE: {
          name: 'Extended service charge code',
          value: 'ES9',
        },
        ES_DAYS: {
          name: 'Days included before extra service charges apply',
          value: 9,
        },
        ES_PRICE: {
          name: 'Extended service fee',
          value: 9,
        },
        EXTRA_LIFTS: {
          name: 'Extra lift fee (EXT)',
          value: 0,
        },
        EXTRA_PICKUP: {
          name: 'Extra residential pick fee (EXR)',
          value: 0,
        },
        EXTRA_YARDS: {
          name: 'Extra yardage fee (EXY)',
          value: 0,
        },
        INCLUDED_TONS: {
          name: 'Weight limit in tons',
          value: 5,
        },
        INITIAL_ADMIN_FEE_APPLIES: {
          name: 'Initial admin fee applies',
          value: false,
        },
        INITIAL_ERF_FEE_APPLIES: {
          name: 'Initial ERF fee applies',
          value: false,
        },
        INITIAL_FRF_FEE_APPLIES: {
          name: 'Initial FRF fee applies',
          value: false,
        },
        MONTHLY_ADMIN_FEE_APPLIES: {
          name: 'Monthly admin fee applies',
          value: false,
        },
        MONTHLY_ERF_FEE_APPLIES: {
          name: 'Monthly ERF fee applies',
          value: false,
        },
        MONTHLY_FRF_FEE_APPLIES: {
          name: 'Monthly FRF fee applies',
          value: false,
        },
        MOVE_FEES: {
          name: 'Container exchange fee (EXC)',
          value: 0,
        },
        OVERAGE_PRICE: {
          name: 'Overage price per ton',
          value: 51,
        },
        RELOCATE: {
          name: 'Relocate fee (REL)',
          value: 181.5,
        },
        REMOVAL: {
          name: 'Container removal fee (REM)',
          value: 0,
        },
        RENEWAL_TERM: {
          name: 'Renewal term in months after contract expires',
          value: 1,
        },
        TERMS_IDENTIFIER: {
          name: 'Terms & Conditions Identifier',
          value: 'CTB_STD_T_01',
        },
        WASHOUT: {
          name: 'Container washout fee (WAS)',
          value: 0,
        },
      },
      id: '111222333',
      initialPrice: {
        amount: 448,
        currency: 'USD',
        display: '$448.00',
      },
      initialSubTotal: {
        amount: 448,
        currency: 'USD',
        display: '$448.00',
      },
      items: [],
      modifierValues: {
        ADDED_FROM_CATEGORY_CODE: 'RES_LGC',
        DELIVERY_AND_PLACEMENT_DETAILS: '',
        ESTIMATED_DELIVERY_DATE: '2019-05-28',
        REQUESTED_COLLECTION_DATE: '2019-06-10',
        REQUESTED_SERVICE_START_DATE: '2100-05-28',
      },
      monthlyPrices: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      monthlySubTotals: {
        year1: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year2: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
        year3: {
          amount: 0,
          currency: 'USD',
          display: '$0.00',
        },
      },
      name: 'Solid Waste Large Container– 20 Yard',
      product: {
        categoryCode: 'RES_LGC',
        code: '020.00_LGC_MSW',
        constituents: [
          {
            name: 'Constituant 0',
          },
        ],
        details: {
          ALLOW_PURCHASE_BY_EXISTING_CUSTOMER: {
            name: 'Allow existing customers',
            value: true,
          },
          ALLOW_PURCHASE_WITHOUT_DIVISION: {
            name: 'Allow purchase without division',
            value: false,
          },
          CATEGORY_STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },
          CONTAINER_SIZE: {
            name: 'Container size code',
            value: '020.00',
          },
          CONTENT_RESTRICTION_NOTE: {
            name: 'Content restrictions note',
            value: '5 Tons',
          },
          DESCRIPTION: {
            name: 'Description',
            value:
              'Our 20 yard container is ideal for roofing projects, small remodels, spring and summer clean outs.',
          },
          GIS_SERVICE_AREA_TYPES: {
            name: 'GIS service area types',
            value: ['Industrial Temp'],
          },
          MAX_QUANTITY: {
            name: 'Max Quantity',
            value: 2,
          },
          MEASUREMENTS: {
            name: 'Measurements',
            value: '22\'9" L x 7\'8" W x 4\'5" H',
          },
          SERVICE_FAMILY: {
            name: 'Service family',
            value: 'LCG',
          },
          SERVICE_GROUP: {
            name: 'Service group',
            value: 'MSW',
          },
          SERVICE_LOCATOR_CODE: {
            name: 'Service locator code to use to determine whether category should be visible',
            value: [
              'Industrial C&D',
              'Industrial C&D Recycling',
              'Industrial OCC Recycling',
              'Industrial Single Stream Recycling',
              'Industrial/rolloff MSW (Compactor & Open Top)',
            ],
          },
          SERVICE_TYPE: {
            name: 'Category Service Type',
            value: 'Industrial Temp',
          },
          SIZE_COMPARISON_NOTE: {
            name: 'Size comparison note',
            value: 'Holds up to around 7-9 full size pickup truck loads',
          },
          SIZE_DESCRIPTION: {
            name: 'Container size human-readable description',
            value: '20 Yard Container',
          },
          STARTING_PRICE_FIELD: {
            name: 'Starting price field (INITIAL or MONTHLY)',
            value: 'INITIAL',
          },

          PRODUCT_FAMILY_NAME: {
            name: 'Product family name',
            value: 'Solid Waste Large Container',
          },
        },
        name: 'Solid Waste Large Container– 20 Yard',
        options: [
          {
            choices: [
              {
                code: 'CF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.COMPACTOR_FLAG,
            name: 'Compactor',
          },
          {
            choices: [
              {
                code: 'SF-0.00',
                name: 'N/A',
              },
            ],
            code: ProductOptionCode.SERVICE_FREQUENCY,
            name: 'Service Frequency',
          },
          {
            choices: [
              {
                code: 'WF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.CASTERS_FLAG,
            name: 'Casters',
          },
          {
            choices: [
              {
                code: 'CTL-RO',
                name: 'RO',
              },
            ],
            code: ProductOptionCode.CONTAINER_TYPE_LGC,
            name: 'Container Type',
          },
          {
            choices: [
              {
                code: 'EF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.ENCLOSURE_FLAG,
            name: 'Enclosure',
          },
          {
            choices: [
              {
                code: 'LF-N',
                name: 'No',
              },
            ],
            code: ProductOptionCode.LOCK_FLAG,
            name: 'Gravity Lock',
          },
          {
            choices: [
              {
                code: 'CL-01',
                name: 'Month-to-Month Service',
              },
            ],
            code: ProductOptionCode.CONTRACT_LENGTH,
            name: 'Contract Length',
          },
        ],
      },
      quantity: 1,
      skuCode: '020.00_LGC_MSW_RO_0.00_01_N_N_N_N',
      imageUrl:
        '/cms/sites/default/files/media/product-images/Cart_95_Trash_Persp_900x548_1.png',
    },
  ],
  monthlyFees: {
    erf: {
      year1: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
      year2: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
      year3: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
    },
    frf: {
      year1: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
      year2: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
      year3: {
        amount: 0,
        currency: 'USD',
        display: '$0.00',
      },
    },
  },
  monthlyTaxes: {
    year1: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
    year2: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
    year3: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
  },
  monthlyTotals: {
    year1: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
    year2: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
    year3: {
      amount: 0,
      currency: 'USD',
      display: '$0.00',
    },
  },
  productQuantity: 3,
  cartLimitErrorCodes: [],
};

export const mockCartYearAmount = {
  ...mockCart,
  monthlyTotals: {
    year1: {
      amount: 2,
      currency: 'USD',
      display: '$0.00',
    },
  },
};

export const mockCartItemless = {
  ...mockCart,
  items: [],
};

export const mockCartLimitErrors = {
  ...mockCart,
  cartLimitErrorCodes: ['code1', 'code2'],
};

export const mockDeliveryDateVoid = {
  ...mockCart,
  items: [
    {
      ...mockCart.items[0],
      modifierValues: {
        ...mockCart.items[0].modifierValues,
        REQUESTED_SERVICE_START_DATE: '2018-06-03',
      },
    },
  ],
};

export const emptySimpleCart: Cart = {
  cartLimitErrorCodes: [],
  cartReset: false,
  isPlaceholderCart: true,
  items: [],
  monthlyTotals: {
    year1: {
      amount: 0,
      currency: '',
      display: '',
    },
    year2: {
      amount: 0,
      currency: '',
      display: '',
    },
    year3: {
      amount: 0,
      currency: '',
      display: '',
    },
  },
  productQuantity: 0,
};
